import { memo, useCallback } from "react";
import * as React from "react";

import { ShareArrowUp } from "@hl/base-components/lib/assets/icons.generated";
import { SECONDARY_COLOR } from "@hl/base-components/lib/theme/button";
import {
  FEATURE_FLAGS,
  useFeatureFlags,
} from "@hl/shared-features/lib/features/auth/hooks";
import { useModalStack } from "@hl/shared-features/lib/features/modal";
import { Button, Stack, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";

import { Auction } from "apollo/graphql.generated";
import { ReactComponent as BrowserIcon } from "assets/icons/browser.svg";
import { ReactComponent as EyeIcon } from "assets/icons/eye-fill.svg";
import ShareSaleModal from "~/features/tokens/sections/ManageToken/modals/ShareSaleModal";

import EmbedSaleModal from "../modals/EmbedSaleModal";

const SaleButtonGroup = ({
  auction,
  auctionUrl,
}: {
  auction: Auction;
  auctionUrl: string;
}) => {
  // const { trackEvent, EventType } = useAnalytics();
  const showEmbed = useFeatureFlags(FEATURE_FLAGS.EMBEDS_SHOW_MODAL);

  const [openedEmbedModal, embedModalActions] = useDisclosure(false);

  const { pushModal } = useModalStack();
  const shareSaleOnClick = useCallback(
    () =>
      pushModal(
        <ShareSaleModal
          data={{
            entity: "auction",
            mintUrl: auctionUrl,
            chainId: auction.chainId!,
          }}
        />,
        {
          size: "lg",
          title: <Text>Share auction page</Text>,
        }
      ),
    [auctionUrl]
  );
  return (
    <Stack p="md">
      <Button
        fullWidth
        component="a"
        color={SECONDARY_COLOR}
        leftIcon={<EyeIcon />}
        target="_blank"
        href={auctionUrl}
      >
        View auction page
      </Button>
      <Button
        fullWidth
        color={SECONDARY_COLOR}
        leftIcon={<ShareArrowUp />}
        onClick={shareSaleOnClick}
      >
        Share auction page
      </Button>
      {showEmbed && (
        <>
          <Button
            fullWidth
            color={SECONDARY_COLOR}
            leftIcon={<BrowserIcon />}
            onClick={embedModalActions.open}
          >
            Embed auction page
          </Button>
          <EmbedSaleModal
            opened={openedEmbedModal}
            onClose={embedModalActions.close}
            collectionId={auction.id!}
            entity={"auction"}
          />
        </>
      )}
    </Stack>
  );
};

export default memo(SaleButtonGroup);
